import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import Home from "@/pages/Home";
import StoriaPage from "@/pages/StoriaPage";
import AtleticaPage from "@/pages/AtleticaPage";
import ConsiglioPage from "@/pages/ConsiglioPage";
import AdempimentiPage from "@/pages/AdempimentiPage";

function ScrollManager() {
  const location = useLocation();
  useEffect(() => {
    if (location.hash) return; // hash navigation is handled by the target page
    const lenis = window.__lenis;
    if (lenis && typeof lenis.scrollTo === "function") {
      lenis.scrollTo(0, { immediate: true });
    } else {
      window.scrollTo(0, 0);
    }
  }, [location.pathname, location.hash]);
  return null;
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.1,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      if (window.__lenis === lenis) delete window.__lenis;
    };
  }, []);

  return (
    <div className="App bg-cream font-body text-navy antialiased overflow-x-hidden">
      <BrowserRouter>
        <ScrollManager />
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/la-storia" element={<StoriaPage />} />
            <Route path="/atletica" element={<AtleticaPage />} />
            <Route path="/consiglio-direttivo" element={<ConsiglioPage />} />
            <Route path="/adempimenti-124-2017" element={<AdempimentiPage />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
